import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
// Remove PersistGate import to avoid type errors
// import { PersistGate } from 'redux-persist/integration/react';
import { store } from './redux/store';
import App from './App';
import './styles/global.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Simplified render without PersistGate to avoid type errors
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
